import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Button } from 'react-bootstrap'
import { Label, Flex, Checkbox, Popup, TextInput, Button as UIButton } from '@leverege/ui-elements'

import { NotifyActions } from '~/actions'
import { exportAndSaveDotEnv } from '~/utils/Export'
import { ListItem } from '~/views'

import style from './apiAccess.css'

class ApiAccessItem extends React.Component {

  static ACTIVATE_EVENT = 'activateApiAccess'
  static DEACTIVATE_EVENT = 'deactivateApiAccess'
  static RENAME_EVENT = 'renameApiAccess'
  static REMOVE_EVENT = 'removeApiAccess'
  static ROLES_EVENT = 'editRolesApiAccess'
  static GO_TO_EVENT = 'goToApiAccessResource'

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  constructor( props ) {
    super( props )
    this.state = {
      popupOpen : false
    }
  }

  copySecret = () => {
    const { dispatch } = this.props
    dispatch( NotifyActions.success( 'Copied', 'The Secret has been copied to your clipboard' ) )
  }

  copyApiKey = () => {
    const { dispatch } = this.props
    dispatch( NotifyActions.success( 'Copied', 'The API Key has been copied to your clipboard' ) )
  }

  onEvent = ( event ) => {
    const { onEvent, item } = this.props
    if ( onEvent ) {
      onEvent( event, item )
    }
  }

  onActiveChanged = ( evt ) => {
    this.onEvent( {
      type : evt.value ? ApiAccessItem.ACTIVATE_EVENT : ApiAccessItem.DEACTIVATE_EVENT,
      target : evt.data
    } )
  }

  onPopupChange = ( { isOpen } ) => {
    if ( isOpen != null ) {
      this.setState( { popupOpen : isOpen } )
    }
  }

  onCopyToClipboard = () => {
    const { dispatch } = this.props
    navigator.clipboard.writeText( this.getImagineCredentialsAsText() )
    dispatch( NotifyActions.success( 'Copied', 'API credentials have been copied to your clipboard' ) )
  }

  onExportDotEnv = () => {
    const { dispatch } = this.props
    exportAndSaveDotEnv( this.getImagineCredentialsAsText(), `${this.getEncodedDisplayName()}.env` )
    dispatch( NotifyActions.success( 'Exported', 'API credentials .env has been exported' ) )
  }

  getImagineCredentialsAsText = () => {
    const { item } = this.props

    const entries = {
      IMAGINE_API_HOST : process.env.IMAGINE_HOST_URL,
      IMAGINE_API_PROJECT_ID : item.projectId,
      IMAGINE_API_API_KEY : item.id,
      IMAGINE_API_API_KEY_SECRET : item.secret,
    }

    return Object.keys( entries ).map( key => `${key}=${entries[key]}` ).join( '\n' )
  }

  getEncodedDisplayName = ( ) => {
    const { item } = this.props
    return item.name.toLowerCase().replace( /[^a-z0-9/-]/gi, '-' )
  }

  render() {
    const { item } = this.props
    const { popupOpen } = this.state

    const info = (
      <div className={style.apiAccessContent}>
        <Flex direction="row">
          <Label className={style.label} variant="input">Api Key</Label>
          <TextInput className={style.apiKey} value={item.id} disabled />
          <CopyToClipboard text={item.id} onCopy={this.copyApiKey}>
            <Button bsSize="small" bsStyle="link" title="Copy to Clipboard">
              {' '}
              <i className="fa fa-copy fa-fw" />
            </Button>
          </CopyToClipboard>
        </Flex>

        <Flex direction="row">
          <Label className={style.label} variant="input">Secret</Label>
          <TextInput className={style.secret} value={item.secret} disabled />
          <CopyToClipboard text={item.secret} onCopy={this.copySecret}>
            <Button bsSize="small" bsStyle="link" title="Copy to Clipboard">
              {' '}
              <i className="fa fa-copy fa-fw" />
            </Button>
          </CopyToClipboard>
        </Flex>

        {item?.resourceType && item?.resourceType !== 'project' && item?.resourceId && (
          <Flex direction="row">
            <Label className={style.label} variant="input">Resource</Label>
            <TextInput
              className={style.resource}
              value={`${item.resourceType} / ${item.resourceId}`}
              data={item}
              onClick={this.onEvent}
              disabled />
            <Button
              bsSize="small"
              bsStyle="link"
              onClick={() => this.onEvent( { type : ApiAccessItem.GO_TO_EVENT, target : item } )}>
              <i className="fa fa-arrow-right fa-fw" />
            </Button>
          </Flex>
        )}

        <Flex direction="row" justify="space-between">
          <UIButton
            variant="secondarySmall"
            onClick={() => this.onEvent( { type : ApiAccessItem.ROLES_EVENT, target : item } )} >
            Edit Roles
          </UIButton>

          <Popup onChange={this.onPopupChange} className={classnames( style.optionsMenu, popupOpen ? style.popupOpen : '' )} title={<i className="fa fa-fw fa-ellipsis-v" />}>
            <Popup.Item className={style.option} onClick={this.onCopyToClipboard}>Copy API credentials to clipboard</Popup.Item>
            <Popup.Item className={style.option} onClick={this.onExportDotEnv}>Export API credentials as .env</Popup.Item>
          </Popup>
        </Flex>
      </div>
    )

    return (
      <ListItem className={style.apiAccessItem}
        areaClass={style.apiAccessItemArea}
        onEvent={this.onEvent}
        item={item}
        title={(
          <Flex variant="rowM">
            <Checkbox
              value={item.active === true}
              eventData={item}
              onChange={this.onActiveChanged} />
            <TextInput
              className={style.itemName}
              value={item.name}
              onChange={( { value, error } ) => {
                if ( !error ) {
                  this.onEvent( { type : ApiAccessItem.RENAME_EVENT, target : item, value } )
                }
              }} />
          </Flex>
        )}
        subtitle={info}
        leftView={this.renderLeft( item )}
        rightView={this.renderRight( item )} />

    )
  }

  renderLeft( item ) {
    return null
    // return (
    //   <Button 
    //     className={item.active === false ? style.apiAccessDisabled : style.apiAccessEnabled} 
    //     onClick={() => { 
    //       this.onEvent( { 
    //         type : item.active ? ApiAccessItem.DEACTIVATE_EVENT : ApiAccessItem.ACTIVATE_EVENT, 
    //         target : item 
    //       } ) 
    //     }}
    //     bsStyle="link">
    //     <i className="fa fa-shield fa-2x" />
    //   </Button>
    // )
  }

  renderRight( item ) {

    return (
      <div>

        <UIButton
          onClick={() => this.onEvent( { type : ApiAccessItem.REMOVE_EVENT, target : item } )}
          variant="link">
          <i className="fa fa-trash fa-fw" />
        </UIButton>

      </div>
    )
  }

}

export default connect()( ApiAccessItem )
